import { isEmpty } from 'lodash-es';
import { showToast } from '@/assets/utils/toast';
import entryMixin from '../../assets/mixins/entry';
import langs from '../../assets/locale/lang/order';
import { PAYMENT_METHODS } from '../../components/order/const';

/** 履约方式 */
const DeliveryType = {
  /** 物流 */
  Express: 'express',
  /** 无物流 */
  Virtual: 'virtual'
};

export default {
  langs,

  mixins: [entryMixin],

  props: {
    /** 订单管理sdk */
    orderSdk: Object,
    /** 地址管理sdk */
    addressManagementSdk: Object,
    /** 商品 */
    products: {
      type: Array,
      default: () => []
    },
    /** 地址 */
    address: {
      type: Object,
      default: () => ({})
    },
    /** 提交禁用 */
    submitDisabled: {
      type: Boolean,
      default: false
    },

    /** 初始化支付方式 */
    initPaymentMethod: {
      type: String,
      default: PAYMENT_METHODS.WECHAT
    },

    /** 是否禁用支付方式 */
    disabledPaymentMethod: {
      type: Boolean,
      default: false
    },

    /** 是否显示支付方式 */
    showPaymentMethod: {
      type: Boolean,
      default: true
    },

    /** 排除的支付方式 */
    excludePaymentMethods: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      /** 地址 */
      // address: {}
      mobile: '',
      paymentMethod: this.initPaymentMethod,
    };
  },

  computed: {
    /** 是否需要地址 */
    ifNeedAddress() {
      if (!this.products) return true;
      // remark 只要一个需要物流就表示需要地址
      return !this.products.every(product => {
        return product.deliveryType === DeliveryType.Virtual;
      });
    },
    /** 总价 */
    totalPrice() {
      return this.products.reduce((total, product) => {
        return total + product.realPrice;
      }, 0);
    }
  },

  methods: {
    // /**
    //  * @description: 获取用户默认地址
    //  * @return {Promise<void>}
    //  */
    // async fetchGetUserAddress() {
    //   if (!this.addressManagementSdk) return;
    //   const res = await this.addressManagementSdk.getDefaultAddressOfUser();
    //   this.address = res;
    // },
    /**
     * @description: 点击地址
     * @return {void}
     */
    navigateToAddressManagement() {
      this.$emit('click-address', this.address);
    },
    /**
     * 统计提交订单按钮点击次数
     */
    trackOrderSubmitButton() {
      if (!this.orderSdk) return;

      const specAttrs = this.getRtasSpecAttrs();
      const trackLogData = {
        event_cata: 'behavior',
        event_type: 'click',
        event_id: 'submit_order_click_button',
        spec_attrs: specAttrs,
      };
      this.orderSdk.trackLog(trackLogData);
    },

    getRtasSpecAttrs() {
      if (!this.products[0]) return {};
      const [product] = this.products;
      return {
        buyType: product.buyType,
        deliveryType: product.deliveryType,
        name: product.name,
        productId: product.productId,
        productType: product.productType,
        productPushRule: product.productPushRule,
      };
    },
    /**
     * @description: 提交订单
     * @return {Promise<void>}
     */
    async handleSubmit() {
      this.trackOrderSubmitButton();

      /** 有物流时判断 */
      if (this.ifNeedAddress && isEmpty(this.address)) {
        showToast({ text: this.iarTrans('order.noAddressSelectedMsg') });
        return;
      }
      /** 无物流时判断 */
      if (!this.ifNeedAddress) {
        try {
          await this.$refs.phoneInputRef.validateField();
        } catch ({ errors }) {
          showToast({ text: errors[0].message });
          throw errors;
        }
      }
      const products = this.products.map(product => {
        return {
          productId: product.productId,
          /** remark 因为目前没有设置数量入口，因此固定是1 */
          quantity: 1
        };
      });
      const address = this.ifNeedAddress ? this.address : { mobile: this.mobile };
      this.$emit('submit', { products, address, paymentMethod: this.paymentMethod });
    },

    handlePhoneInputFocus() {
      this.$emit('order-focus');
    },

    handlePhoneInputBlur() {
      this.$emit('order-blur');
    },

    /**
     * 处理支付方式变更
     * @param {string} method 支付方式
     */
    handlePaymentMethodChange(method) {
      this.paymentMethod = method;
      this.$emit('change-payment-method', method);
    },
  }
};
